export const activeMarketLabelsConstants = {
  CATCH_ACTIVE_MARKET_LABELS_ERROR: 'FETCH_ACTIVE_MARKET_LABELS',
  RECEIVE_ACTIVE_MARKET_LABELS: 'RECEIVE_ACTIVE_MARKET_LABELS',
  REQUEST_ACTIVE_MARKET_LABELS: 'REQUEST_ACTIVE_MARKET_LABELS',
};

export default activeMarketLabelsConstants;
